import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { OsAuthProvider } from '@os/auth-client/react';
import '@os/ui/styles.css';
import '../styles/globals.css';
import { auth } from './auth';
import { Providers } from './providers';
import { router } from './router';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <OsAuthProvider auth={auth}>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </OsAuthProvider>
  </React.StrictMode>,
);
